import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChartComponentBase, ChartType } from '../chart.types';
import formatNumber from 'accounting-js/lib/formatNumber.js';

@Component({
  selector: 'chart-donut',
  templateUrl: './donut.component.html',
  styleUrls: ['./donut.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartDonutComponent extends ChartComponentBase {
  prepareChart(): void {
    const [firstSeries] = this.chartDef.series ?? [];

    this.chartOptions = {
      colors: this.defaultColors,
      chart: {
        height: this.height ? this.height : this.fillMode ? '100%' : 'auto',
        type: ChartType.Donut,
        events: {
          dataPointSelection: (event, chart, options) => this.dataPointSelection.emit(options),
        },
        animations: {
          enabled: false,
        },
      },
      markers: {
        size: 0,
      },
      stroke: {
        curve: 'straight',
        width: 2,
      },
      legend: {
        position: 'bottom',
      },
      series: firstSeries?.data,
      responsive: [
        {
          breakpoint: 350,
          options: {
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      labels: this.chartDef.rankedCategories,
      dataLabels: {
        enabled: true,
        formatter: (val, opts) => {
          return this.formatter(opts.w.config.series[opts.seriesIndex]);
        },
      },
      tooltip: {
        theme: 'dark',
        x: {
          format: 'MMM dd, yyyy',
        },
        y: {
          formatter: (value, opts) => {
            let formattedValue = formatNumber(opts.globals.seriesPercent[opts.seriesIndex][0], {
              precision: 2,
            });
            return formattedValue + '%';
          },
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
              },
              value: {
                show: true,
              },
              total: {
                show: true,
                showAlways: true,
                formatter: function (w) {
                  let value = w.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                  return formatNumber(value, {
                    precision: 0,
                  });
                },
              },
            },
          },
        },
      },
    };
  }

  private formatter(val: any): string {
    if (Number.isNaN(Number(val))) {
      return val;
    }

    if (this.chartDef.formatting && this.chartDef.formatting?.type) {
      if (this.chartDef.formatting?.type == 'number') {
        //return this.formatNumber.transform('23232223.45', 0);
        return formatNumber(val.toString(), {
          precision: 0,
        });
      } else if (this.chartDef.formatting?.type == 'percent') {
        let formattedValue = formatNumber(val.toString(), {
          precision: 2,
        });
        return formattedValue + '%';
      } else if (this.chartDef.formatting?.type == 'money') {
        let formattedValue = formatNumber(val.toString(), {
          precision: 2,
        });
        return '$' + formattedValue;
      }
    } else {
      let formattedValue = formatNumber(val.toString(), {
        precision: 2,
      });
      return formattedValue;
    }
  }
}
